document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  if (!variant) return;

  const input = document.querySelector(`[data-variant-id="${variant.id}"]`);
  if (!input) return;

  const imageUrl = input.dataset.variantImage;
  const img = document.querySelector('slideshow-slide img');
  if (!img) return;

  if (imageUrl) {
    // Guardar original si no está guardado
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset;
    }
    img.src = imageUrl;
    img.srcset = imageUrl;
  } else {
    // Variante 1 — restaurar originales
    if (img.dataset.originalSrc) {
      img.src = img.dataset.originalSrc;
      img.srcset = img.dataset.originalSrcset;
    }
  }
});